import React, { useRef, useState } from 'react'
import { Form } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCloudUpload } from '@fortawesome/free-solid-svg-icons'
import { toast } from 'react-toastify'

// Book cover upload limits (BUG-001)
const MAX_SIZE_MB = 5
const ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/gif']
const MIN_DIMENSION_PX = 100
const MAX_DIMENSION_PX = 4000

const BookImage = ({ onImageSelect, updateBookPortrait }) => {
  const [image, setImage] = useState(null)
  const [fileName, setFileName] = useState('No selected file')
  const fileInputRef = useRef(null)

  const handleImageChange = (e) => {
    const file = e.target.files[0]
    if (!file) return

    const rejectFile = (message) => {
      toast.error(message)
      e.target.value = ''
    }

    if (!ALLOWED_TYPES.includes(file.type)) {
      rejectFile('Unsupported file type. Use JPG, PNG, WEBP or GIF.')
      return
    }

    if (file.size > MAX_SIZE_MB * 1024 * 1024) {
      rejectFile(`Image exceeds the ${MAX_SIZE_MB}MB limit. Please choose a smaller file.`)
      return
    }

    const objectUrl = URL.createObjectURL(file)
    const img = new Image()
    img.onload = () => {
      if (img.width < MIN_DIMENSION_PX || img.height < MIN_DIMENSION_PX) {
        URL.revokeObjectURL(objectUrl)
        rejectFile(`Image must be at least ${MIN_DIMENSION_PX}×${MIN_DIMENSION_PX} pixels.`)
        return
      }
      if (img.width > MAX_DIMENSION_PX || img.height > MAX_DIMENSION_PX) {
        URL.revokeObjectURL(objectUrl)
        rejectFile(`Image must not exceed ${MAX_DIMENSION_PX}×${MAX_DIMENSION_PX} pixels.`)
        return
      }
      // Reuse the validated object URL as the preview source.
      setFileName(file.name)
      setImage(objectUrl)
      onImageSelect(file)
      updateBookPortrait(file.name)
    }
    img.onerror = () => {
      URL.revokeObjectURL(objectUrl)
      rejectFile('Could not read the selected image. Please choose a valid file.')
    }
    img.src = objectUrl
  }

  return (
    <div
      className='custom-image-form'
      onClick={() => fileInputRef.current.click()}
    >
      <Form.Control
        ref={fileInputRef}
        className='input-field'
        type='file'
        name='portrait'
        accept='image/*'
        // value={fileName}
        onChange={handleImageChange}
        hidden
      />
      {image ? (
        <img src={image} width={140} height={230} alt={fileName} />
      ) : (
        <div>
          <FontAwesomeIcon size='3x' icon={faCloudUpload} />
          <p>Import book cover</p>
        </div>
      )}
    </div>
  )
}

export default BookImage
